import React from 'react'
import { Row, Col } from 'antd'
import BrokerQuickLinks from 'components/broker/BrokerQuickLinks'
import AddFaq from 'components/shared/AddFaq'
import ArticleList from 'components/shared/ArticleList'
import QuickLinks from 'components/shared/QuickLinks'
import PropTypes from 'prop-types'
import DescriptionHead from './descriptionhead'
import Review from './review'

export default function SoftwareContent({ software }) {
  const {
    articles: { data: articles },
    softwareRelatedArticles,
    relatedSoftwares,
  } = software
  const input = {
    software: software.id,
    article_type: 'faq',
  }
  const title = 'Related Discussions'
  const linkList = []
  if (softwareRelatedArticles) {
    softwareRelatedArticles.map((article) => {
      linkList.push({
        href: '/article/[slug]/',
        as: `/article/${article.slug}/`,
        linkText: ` ${article.title}`,
        textDescription: `${article.short_description}`,
      })
      return linkList
    })
  }
  const relatedSoftwaresLinkList = []
  const listTitle = 'Similar Software'
  if (relatedSoftwares) {
    relatedSoftwares.map((related_Software) => {
      relatedSoftwaresLinkList.push({
        href: '/software/[slug]/',
        as: `/software/${related_Software.slug}/`,
        linkText: ` ${related_Software.name}`,
      })
      return relatedSoftwaresLinkList
    })
  }
  const broker = software.broker?.data?.attributes
  return (
    <Row className="page-wrapper page">
      <Col xs={24} md={16}>
        <DescriptionHead software={software} />
        <Review software={software} />
        <AddFaq input={input} />
      </Col>
      <Col xs={24} md={8}>
        <BrokerQuickLinks broker={broker} RenderReview />
        <QuickLinks title={title} linkList={linkList} />
        <QuickLinks title={listTitle} linkList={relatedSoftwaresLinkList} />
      </Col>
      <Col xs={24} md={16}>
        <ArticleList articles={articles} type="softwares" />
      </Col>
    </Row>
  )
}

SoftwareContent.propTypes = {
  software: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    broker: PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      commodity_trading: PropTypes.string,
      currency_trading: PropTypes.string,
    }),
  }).isRequired,
}
